export const INTERNAL_USER_EMAIL_DOMAINS = [
  'useindigo.com',
  'bloomoffer.com',
  'indigo.app',
] as const;

export const INTERNAL_USER_EMAIL_LIKE_PATTERNS = [
  ...INTERNAL_USER_EMAIL_DOMAINS.map((domain) => `%@${domain}`),
] as const;

export function isInternalUserEmail(email: string | null | undefined): boolean {
  const normalizedEmail = email?.trim().toLowerCase();

  if (!normalizedEmail) {
    return false;
  }

  return INTERNAL_USER_EMAIL_DOMAINS.some((domain) =>
    normalizedEmail.endsWith(`@${domain}`)
  );
}
